import React from 'react';
import ReactDOM from 'react-dom/client';
import { PostHogContext, PostHogProvider } from '@posthog/react';
import { initSentry } from './lib/sentry';
import { posthogDevStub } from './lib/posthogDevStub';
import { SESSION_TOKEN_KEY } from './api/workosAuth';
import App from './App';
import './index.css';

initSentry();

// Run before any React code: store session token from redirect fragment so auth requests have it.
if (typeof window !== 'undefined') {
  const hash = window.location.hash;
  if (hash.startsWith('#session=')) {
    try {
      const token = decodeURIComponent(hash.slice(9).trim());
      if (token) sessionStorage.setItem(SESSION_TOKEN_KEY, token);
    } catch {
      // ignore
    }
  }
}

const posthogKey = (import.meta.env.VITE_PUBLIC_POSTHOG_KEY ?? '').trim();
const posthogHost = (import.meta.env.VITE_PUBLIC_POSTHOG_HOST ?? 'https://eu.i.posthog.com').trim();
const posthogOptions = {
  api_host: posthogHost,
  person_profiles: 'identified_only' as const,
  defaults: '2026-01-30',
  capture_pageview: true,
  autocapture: true,
  session_recording: {
    maskAllInputs: true,
  },
} as const;

/** PostHog is production-only so local dev does not flood the project with events. */
const posthogEnabled = import.meta.env.PROD && Boolean(posthogKey);

const root = (
  <React.StrictMode>
    {posthogEnabled ? (
      <PostHogProvider apiKey={posthogKey} options={posthogOptions}>
        <App />
      </PostHogProvider>
    ) : (
      <PostHogContext.Provider value={{ client: posthogDevStub, bootstrap: undefined }}>
        <App />
      </PostHogContext.Provider>
    )}
  </React.StrictMode>
);

ReactDOM.createRoot(document.getElementById('root')!).render(root);